import { Component, effect, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DEFAULT_LANGUAGES, ILanguage } from '@web/dtos';
import { LanguageStore } from '../../../services/api/language/language-store.service';
import { DropDownComponent } from '../form-inputs/drop-down/drop-down.component';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../services/language/language.service';

@Component({
  selector: 'aw-shop-language-drop-down',
  templateUrl: './shop-language-drop-down.component.html',
  imports: [DropDownComponent, ReactiveFormsModule],
})
export class ShopLanguageDropDownComponent implements OnDestroy {
  private readonly formBuilder: FormBuilder = inject(FormBuilder);
  protected readonly languageStore: LanguageStore = new LanguageStore();
  protected readonly languageService: LanguageService = inject(LanguageService);
  protected readonly shopLanguageControl: FormControl<ILanguage> =
    this.formBuilder.nonNullable.control(DEFAULT_LANGUAGES[0]);
  private readonly subscription: Subscription = new Subscription();

  constructor() {
    effect(() => {
      const standardLanguage: ILanguage | undefined = this.languageStore
        .activeLanguages()
        .find((language: ILanguage) => language.isStandard);
      if (standardLanguage) {
        this.shopLanguageControl.setValue(standardLanguage);
      }
    });
    this.subscription.add(
      this.shopLanguageControl.valueChanges.subscribe(
        (chosenLanguage: ILanguage) => {
          this.languageService.setActiveLanguage(chosenLanguage.prefix);
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
